import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { CustomerVaultsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface UseVaultDeleteParams {
  userId: number;
  vaultId: number;
  tenantId: number;
}

export const useVaultDelete = () => {
  const accessToken = useAccessToken();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isSuccess, isError, error } =
    useMutation({
      mutationFn: async ({
        userId,
        vaultId,
        tenantId,
      }: UseVaultDeleteParams) => {
        if (!accessToken) {
          throw new Error("Authentication token is required");
        }

        const service = createAuthenticatedApi(
          CustomerVaultsApi,
          accessToken,
        );

        await service.apiUsersUserIdVaultsUserVaultIdDelete({
          userId,
          userVaultId: vaultId,
          xTenantID: tenantId,
        });

        return { userId, vaultId };
      },
      onSuccess: ({ userId }) => {
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.CustomerVaults, userId],
        });
      },
    });

  return { mutate, mutateAsync, isPending, isSuccess, isError, error };
};
